import React from "react";
import { Button, ButtonGroup, ButtonGroupProps, ButtonProps } from "semantic-ui-react";

type BPButtonProps = ButtonProps & {

};

export const BPButton = React.forwardRef<HTMLButtonElement, BPButtonProps>((props, ref) => {
    return <Button {...props} ref={ref}>{props.children}</Button>
});

type BPButtonGroupProps = ButtonGroupProps & {

};
export const BPButtonGroup = React.forwardRef<HTMLDivElement, BPButtonGroupProps>((props, ref) => {
    return <ButtonGroup {...props} ref={ref}>{props.children}</ButtonGroup>
});